import { PublicPageTemplate } from "./PublicPageTemplate";

const SolutionLibrairiesPage = () => (
  <PublicPageTemplate
    badge="Solution Librairies"
    title="Réinventez votre"
    highlight="librairie"
    description="Gestion intelligente des stocks, recommandations personnalisées et fidélisation client propulsées par l'IA."
  />
);
export default SolutionLibrairiesPage;
